import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../content/siteContent";

export function EditorialMarquee() {
  return (
    <div className="bg-white border-b border-black/5 py-5 overflow-hidden" data-testid="treatment-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-heading text-sm font-semibold tracking-[0.18em] sm:tracking-[0.3em] uppercase text-ink/40">
            {item}
            <span className="w-1.5 h-1.5 rounded-full bg-brand/50" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
